import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { SortColumn, SortDirectionType } from '@core/types';
import { SortEvent } from '@core/interfaces';
import { rotate } from '@core/helpers';

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()',
  },
})
export class TableSortDirective<T> {
  @Input() sortable: SortColumn<T> = '';
  @Input() direction: SortDirectionType = '';
  @Output() sort = new EventEmitter<SortEvent<T>>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}

/*
@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()',
  },
})
export class SortDirective {
  @Input() sortable: SortColumn<Country> = '';
  @Input() direction: SortDirectionType = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
 */
